import React, { useEffect, useState } from "react";
import { api } from "../api";

export function ActivateAccount() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [completed, setCompleted] = useState(false);

  const [token] = useState(
    () => new URLSearchParams(window.location.search).get("token") || ""
  );

  useEffect(() => {
    // Rimuove il token dall'URL visibile e dalla cronologia corrente.
    if (token) {
      window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname
      );
    }
  }, [token]);

  const submit = async (event) => {
    event.preventDefault();
    setError("");

    if (!token) {
      setError("Collegamento di attivazione non valido.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Le password inserite non coincidono.");
      return;
    }

    const bytes = new TextEncoder().encode(password).length;

    if (password.length < 8 || bytes > 72) {
      setError("La password deve contenere almeno 8 caratteri e non superare 72 byte.");
      return;
    }

    setLoading(true);

    try {
      await api.post("/auth/activate-account", {
        token,
        password
      });

      setCompleted(true);
      setPassword("");
      setConfirmPassword("");

    } catch (err) {
      setError(
        err.response?.data?.detail ||
        "Impossibile completare l'attivazione."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-shell">
      <section className="login-panel">
        <div className="brand-mark">
          <b>118</b>Finder
        </div>

        <div className="login-copy">
          <span className="eyebrow">SICUREZZA ACCOUNT</span>
          <h1>Attivazione account</h1>
          <p>
            Imposta una password personale per accedere
            alla piattaforma 118Finder.
          </p>

          {completed ? (
            <div className="login-form">
              <div className="success">
                Account attivato correttamente.
                Ora puoi effettuare l'accesso.
              </div>
              <a className="primary-btn" href="/">
                Vai al login
              </a>
            </div>
          ) : (
            <form className="login-form" onSubmit={submit}>
              {!token && (
                <div className="error">
                  Collegamento di attivazione mancante.
                </div>
              )}

              <label>
                Nuova password
                <input
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
              </label>

              <label>
                Conferma password
                <input
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                />
              </label>

              {error && <div className="error">{error}</div>}

              <button
                className="primary-btn"
                type="submit"
                disabled={loading || !token}
              >
                {loading ? "Attivazione…" : "Attiva account"}
              </button>
            </form>
          )}
        </div>
      </section>

      <aside className="login-aside">
        <div className="brand-mark">
          <b>118</b>Finder
        </div>
        <div className="login-copy">
          <span className="eyebrow">ACCESSO SICURO</span>
          <h1>Benvenuto in 118Finder</h1>
          <p>
            La tua password sarà utilizzata esclusivamente
            per accedere al tuo account personale.
          </p>
        </div>
      </aside>
    </main>
  );
}
